import React, { useEffect, useRef, useState } from "react";
import anime from "animejs";
import { apiCall, mediaUrl } from "../util";
import axios from "axios";
import { logofloating } from "../Image";
import { setTopSpaceHeight } from "../custom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const HealthcareStory = () => {
  const titleRef = useRef(null);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (titleRef.current) {
      anime({
        targets: titleRef.current.children,
        opacity: [0, 1],
        translateX: [-30, 0],
        duration: 800,
        delay: 0,
        easing: "easeOutQuad",
        stagger: 300, // Stagger animation for each child element
      });
    }
  }, []);
useEffect(() => {
    if (typeof setTopSpaceHeight === "function") {
      setTopSpaceHeight();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiCall + "about_us/getall");
        setData(response.data[0]);
        // console.log(response.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <section className="top-space-margin position-relative pt-60px pb-60px page-title-big-typography bg-sg-light-gradient -bg-base-color-light">
        <img src={logofloating} className="floating-logo" alt="floating-logo" />
        <div className="container">
          <div className="row -extra-very-small-screen align-items-center">
            <div
              className="col-lg-6 col-sm-8 position-relative page-title-extra-small"
              ref={titleRef} // Use ref here
            >
              <h1 className="mb-20px xs-mb-20px text-dark-gray text-shadow-medium">
                <span className="w-30px h-2px bg-base-color d-inline-block align-middle position-relative top-minus-2px me-10px"></span>
                About us
              </h1>
              <h4 className="text-dark-gray text-shadow-medium fw-bold ls-minus-2px mb-0">
                <span className="text-gradient-sg-red-purple">
                  {data?.title || <Skeleton width={"100%"} />}
                </span>
              </h4>
            </div>
          </div>
        </div>
      </section>

      <section className="sg-li bg-white half-section -pb-0 text-dark-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              {data?.description ? (
                data.description.split("\n").map((para, index) => (
                  <p key={index}>
                    {para}
                  </p>
                ))
              ) : (
                <>
                  <Skeleton height={90} />
                  <Skeleton height={90} />
                  <Skeleton height={90} />
                  <Skeleton height={90} />
                </>
              )}
            </div>
            <div className="col-lg-5">
              {data?.image ? (
                <img
                  src={`${mediaUrl}/${data.image}`}
                  alt="Healthcare Story"
                  className="sg-img-radius h-100 object-fit-cover"
                />
              ) : (
                <Skeleton
                  height={400}
                  style={{
                    borderRadius: "0px 60px 0px 60px",
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HealthcareStory;
